/**
 * Hono RPC client rely on untranspiled type definition imported from BFF application.
 * Which makes build processes of BFF application and marketplace application independent.
 *
 * @remarks
 * However, it can lead to potential performance issues with typescript during development.
 *
 * If it will be a problem, BFF application have to compile type definition during the build.
 * So, Marketplace application will import already transpiled type definition.
 *
 * This approach will move havy typescript tasks to build process of BFF application.
 * However, build of marketplace application will depend on build of BFF application.
 *
 * @see {@link https://hono.dev/docs/guides/rpc#compile-your-code-before-using-it-recommended}
 */

import type { MarketRpcType } from "anaconda-market-bff/app-type"
import { hc } from "hono/client"

type MarketClient = ReturnType<typeof hc<MarketRpcType>>

/**
 * Backward-compatible API client type.
 * Provides `api` property to match existing code pattern: client.api.collections
 * Routes are available at /api/market/* on the BFF
 */
export type BffApiClient = { api: MarketClient }

/**
 * Creates API client with `api` property for backward compatibility.
 * Existing code using `client.api.collections` maps to /api/market/collections
 */
export const getApiClient = (bffBaseUrl: string): BffApiClient => {
  const client = hc<MarketRpcType>(`${bffBaseUrl}/api/market`)
  return { api: client }
}
